import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import validator from 'validator';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
//styles
import 'bootstrap/dist/css/bootstrap.css';
import './footer-social.styl';
//text
import { FooterSocialText as FooterSocialTextEN } from '../../../input-text/en/footer';
import { FooterSocialText as FooterSocialTextNL } from '../../../input-text/nl/footer';
//social images
// import fb from '../../media/social/aircheckr-fb.png';
// import lin from '../../media/social/aircheckr-linkedin.png';
// import twt from '../../media/social/aircheckr-twitter.png';

class FooterSocial extends React.Component {

  constructor(){
    super();
    this.state = {
      email: '',
      popupText: 'Please, provide a valid email address'
    }
    this.setLocale = this.setLocale.bind(this);
  }

  inputChange = (e) => {
    this.setState({[e.target.name]: e.target.value});
    // this.setState({popupText: ''});
  }

  validate = () => {
    let valid_email = validator.isEmail(this.state.email);
    if(!valid_email)
      this.setState({'popupText': 'Please, provide a valid email address'});
    return valid_email;
  }

  submitForm = (e) => {
    e.preventDefault();

    //const url = 'http://localhost:8080/users/subscribe';
    //const url = 'http://52.211.18.190:4433/users/subscribe';
    const url = 'https://api.aircheckr.com/users/subscribe';

    if(this.validate()){
      axios.post(url, {
        email: this.state.email,
      })
      .then(response => {
        this.setState({email: '', popupText: response.data.status});
      })
      .catch(err => {
        if(err.response)
          this.setState({popupText: err.response.data.status});
        else
          this.setState({popupText: 'Something went wrong. Please, try again later.'});
      });
    }
  }

  popup = () => {
    return (
      <Tooltip className="in" id="tooltip-subscribe">
        <span>{this.state.popupText}</span>
      </Tooltip>
    );
  }

  setLocale(locale) {
      this.FooterSocialText = null;
      switch (this.props.locale) {
          case 'en':
              this.FooterSocialText = FooterSocialTextEN;
              break;
          case 'nl':
              this.FooterSocialText = FooterSocialTextNL;
              break;
          default:
              this.FooterSocialText = FooterSocialTextEN;
      }
  }

  render() {
    this.setLocale(this.props.locale);

    return (
      <div className='footer-social'>
        <span className='footer-social__title'>{this.FooterSocialText.title}</span>
        <form onSubmit={this.submitForm}>
          <input className='footer-social__input' type='text' name='email' placeholder='email@company.com' value={this.state.email} onChange={this.inputChange}/>
          <OverlayTrigger className='form-overlay' trigger={'focus'} placement="top" overlay={this.popup()}>
            <input className="footer-social__submit button col-xs-12" type="submit" value={ this.FooterSocialText.subscribe } />
          </OverlayTrigger>
          <br/>
        </form>
        {
          /*Social media is not included in this version*/
          /*<table className="social-icons">
          <tbody>
            <tr>
              <td><a href='#'><img src={fb} alt='facebook' /></a></td>
              <td><a href='#'><img src={lin} alt='linkedin' /></a></td>
              <td><a href='#'><img src={twt} alt='tweeter' /></a></td>
            </tr>
          </tbody>
        </table>*/}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.locale.value,
  };
};

export default connect(mapStateToProps, null)(FooterSocial);



// WEBPACK FOOTER //
// ./src/containers/footer/footer-social/footer-social.js